// DEBUG: Constants so we don't forget to change the routes in all places when changing to the final locations.
// Inline these into those places when final.
export const CONVOV2_HOME_PAGE_ROUTE = '/convo-v2/conversations';
export const CONVOV2_APP_LAUNCH_ROUTE = '/convo-v2/launch-app';
export const CONVOV2_LK_TRANSCRIPT_ROUTE = '/web/convo-v2-lk/transcript';
export const CONVOV2_LK_CONVERSATIONS_ROUTE = '/web/convo-v2-lk-conversations';
export const CONVOV2_LK_SCRIBE_LOBBY_ROUTE = '/web/scribe-lobby';
export const CONVOV2_VERSION_MISMATCH_ROUTE = '/web/conversation-version-mismatch';
export const LK_KEYBOARD_MESSAGE_MAX_LENGTH = 1000;
export const LK_SCRIBE_CHAT_MAX_LENGTH = 1000;
export const LK_TTS_MESSAGE_MAX_LENGTH = 200;
const CONVOV2_LK_TRANSCRIPT_ALLOWED_SEARCH_PARAMS = ['roomId'] as const;

export const hasLegacyInviteToken = (search: string) => {
  return Boolean(new URLSearchParams(search).get('token')?.trim());
};

export const hasLKInviteRoomId = (search: string) => {
  return Boolean(new URLSearchParams(search).get('roomId')?.trim());
};

export const isValidLKInviteLocation = (pathname: string, search: string) => {
  return pathname === CONVOV2_LK_TRANSCRIPT_ROUTE && hasLKInviteRoomId(search) && !hasLegacyInviteToken(search);
};

export const getLKTranscriptSearch = (search: string) => {
  const currentParams = new URLSearchParams(search);
  const nextParams = new URLSearchParams();

  for (const key of CONVOV2_LK_TRANSCRIPT_ALLOWED_SEARCH_PARAMS) {
    const value = currentParams.get(key);
    if (value != null) {
      nextParams.set(key, value);
    }
  }

  const filteredSearch = nextParams.toString();
  return filteredSearch ? `?${filteredSearch}` : '';
};
